import type { RootState } from '../../store';
import { log } from '../log';
import { makeUrlFromState } from '../url/fromState';

export function historyPayloadSelector(state: RootState) {
  const { catalog, category, indicator, intl, item, pane, tree } = state;

  return JSON.parse(
    JSON.stringify({
      catalog,
      category,
      intl,
      indicator,
      item,
      pane,
      tree,
    }),
  );
}

export function replaceHistory(state: RootState, reason: string) {
  const payload = historyPayloadSelector(state);
  const { href } = window.location;
  log(`replaceHistory ${reason}`, payload, href);
  window.history.replaceState(payload, reason, href);
}

export function pushHistoryFromState(state: RootState, reason: string) {
  const payload = historyPayloadSelector(state);
  const href = makeUrlFromState(state);
  log(`pushFromState ${reason}`, payload, href);
  window.history.pushState(payload, reason, href);
}

export function replaceHistoryFromState(state: RootState, reason: string) {
  const payload = historyPayloadSelector(state);
  const href = makeUrlFromState(state);
  log(`replaceFromState ${reason}`, payload, href);
  window.history.replaceState(payload, reason, href);
}
